var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlasChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.8 106.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d92d27;\n      }\n\n      .st0, .st1 {\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: #143156;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,47.5c2.7-13.1,14.3-22.9,28.1-22.9s25.5,9.8,28.1,22.9h18.7c-2.9-23.3-22.8-41.4-46.9-41.4S13.9,24.2,11.1,47.5h18.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,36.2c9.5,0,17.1,7.7,17.1,17.1s-7.7,17.1-17.1,17.1-17.1-7.7-17.1-17.1,7.7-17.1,17.1-17.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.1,59.1c2.9,23.3,22.8,41.4,46.9,41.4s44-18.1,46.9-41.4h-18.7c-2.7,13.1-14.3,22.9-28.1,22.9s-8.3-.9-12-2.6l-16.2,4.4,4-15c-1.9-2.9-3.2-6.2-3.9-9.7H11.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasChatIcon);
export default __webpack_public_path__ + "static/media/atlas_chat_icon.c1efe492d338f9de439fdabe5744bfac.svg";
export { ForwardRef as ReactComponent };